import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge, FormGroup } from "reactstrap"
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { ImageBaseUrl } from "helpers/file_upload_helper";
import { VEHICLES_SEARCH } from "helpers/api_endpoints";
import NoImage from "assets/images/no-image.png";
import Select from "react-select";
//meta title
document.title = "Vehicles";
const VehicleList = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [id, setId] = useState(0);
	const [status, setStatus] = useState(false);
	const [plateNo, setPlateNo] = useState(false);
	const [driverName, setDriverName] = useState('');
	const [name, setName] = useState('');
	const [loading, setLoading] = useState(true);
	const [vehicles, setVehicles] = useState([]);
	const [filteredVehicles, setFilteredVehicles] = useState([]);
	const [filters, setFilters] = useState({});
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [totalItems, setTotalItems] = useState(0);
	const [successMsg, setsuccessMsg] = useState('');

	useEffect(() => {
		successMessage();
		post(`${VEHICLES_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
			.then(response => {
				const data = response.data;
				if(filteredVehicles.length > 0)
					setVehicles(filteredVehicles);
				else
					setVehicles(data.data);
                setTotalPages(data.pagination.totalPages);
				setTotalItems(data.pagination.totalItems);
				setPage(data.pagination.currentPage);
				setLoading(false);
			})
			.catch(error => {
				if (error.response.status == 400) {
					console.log(error);
				}
			})
	}, [page, filters]);

	useEffect(() => {
		setVehicles(filteredVehicles);
	}, [filteredVehicles]);

	const successMessage = () => {
		if (location.state) {
			setsuccessMsg(location.state.successMsg);
			setTimeout(() => {
				location.state.successMessage = '';
				setsuccessMsg('');
			}, 4000)
		}
	};

	const handleFilter = (type, value) => {
		const filtvalues = {};
		if (value) {
			switch (type) {
				case 'id':
					setId(value);
					filtvalues.id = value;
					break;
				case 'status':
					setStatus(!status);
                    const temp = vehicles.map(el => {
                        if(parseInt(el.acceptedDocuments) < 1 && status) return el;
                    });
					console.log('temp',status,vehicles,temp);
                    if(temp[0] != undefined)
                        setFilteredVehicles(temp);
                    else
                    {
                        setFilteredVehicles([]);
                    }
					break;
				case 'driver':
					setDriverName(value);
					filtvalues.driverName = value;
					break;
				case 'plateNo':
					setPlateNo(value);
					filtvalues.plateNo = value;
					break;
				default:
					break;
			}
		}
		setFilters(filtvalues);
	}

	const handlePrevPage = () => {
		if (page > 1) {
			setPage(page - 1);
		}
	};

	const handleNextPage = () => {
		if (page < totalPages) {
			setPage(page + 1);
		}
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs title="Home" breadcrumbItem="Vehicles" />
					<Row>
						<Col xl={12}>
							<Card>
								<br></br>
								{successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
								<CardTitle>
									<Link to="/vehicles/add" >
										<button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
									</Link>
								</CardTitle>
								<div style={{ margin: "25px" }}>
									<div className="row">
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>ID</Trans></Label>
                                            <Input
                                                name="id"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('id', e.target.value)}
                                                onKeyDown={(e) => handleFilter('id', e.target.value)}
                                            ></Input>
                                            </div>
                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Verified</Trans></Label>
                                                <FormGroup switch>
                                                <Input
                                                    type="switch"
                                                    size="md"
                                                    checked={status}
                                                    onClick={() => {
                                                        handleFilter('status','0');
                                                    }}
                                                    />
                                                </FormGroup>                                           
											</div>
                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Plate Number</Trans></Label>
                                                <Input
                                                    name="id"
                                                    className="form-control"
                                                    placeholder=""
                                                    type="text"
                                                    onChange={(e) => handleFilter('plateNo', e.target.value)}
                                                    onKeyDown={(e) => handleFilter('driver', e.target.value)}
                                                ></Input>
                                            </div>
                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Allocated Driver</Trans></Label>
                                                <Input
                                                    name="id"
                                                    className="form-control"
                                                    placeholder=""
                                                    type="text"
                                                    onChange={(e) => handleFilter('driver', e.target.value)}
                                                    onKeyDown={(e) => handleFilter('driver', e.target.value)}
                                                ></Input>
                                            </div>
									</div>
								</div>


								<CardBody>
									<div className="table-responsive">
										<Table className="table table-striped table-bordered mb-0">
											<thead>
												<tr>
													<th><Trans>ID</Trans></th>
													<th className="text-center"><Trans>Image</Trans></th>
													<th><Trans>Name</Trans></th>
													<th><Trans>Model Name</Trans></th>
													<th><Trans>Color</Trans></th>
													<th><Trans>Capacity</Trans></th>
													<th><Trans>Ownership</Trans></th>
													<th><Trans>Plate No</Trans></th>
													{/* <th><Trans>Allocated Driver</Trans></th> */}
													<th><Trans>Status</Trans></th>
													{/* <th><Trans>Document Status</Trans></th> */}
													<th>#</th>
												</tr>
											</thead>
											<tbody>
												{loading ? <tr><th colSpan={9} className="text-center"><Loader></Loader></th></tr> : null}
												{
													vehicles.map((vehicle, index) => (
														<tr key={index}>
															<td>{vehicle.id}</td>
															<td className="text-center">{(vehicle.symbol) ? <img style={{ background: "#f5f5f5", padding: "15px", borderRadius: "5px" }} src={`${ImageBaseUrl}${vehicle.symbol}`} width={80}></img> : <img src={NoImage} width={70} style={{ background: "#f5f5f5", padding: "8px", borderRadius: "5px" }}></img>}</td>
															<td>{vehicle.name}</td>
															<td>{vehicle.modelName || "-"}</td>
															<td>{vehicle.color || "-"}</td>
															<td>{vehicle.capacity || "-"}</td>
															<td>{vehicle.ownership || "-"}</td>
															<td>{vehicle.plateNo || "-"}</td>
															{/* <td>{vehicle.Drivers[0]?vehicle.Drivers[0].name : "-"}</td> */}
                              <td>{(vehicle.status == 1) ? <Badge className="bg-success"><Trans>Active</Trans></Badge> : <Badge className="bg-danger"><Trans>Non Active</Trans></Badge>}</td>
															{/* <td>{(vehicle.notAcceptedDocuments > 0) ? <Badge className="bg-danger"><Trans>Unverified</Trans></Badge> : <Badge className="bg-success"><Trans>Verified</Trans></Badge>}</td> */}
															<td><Link to={`/vehicles/edit/${vehicle.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
																<Link to={`/vehicles/remove/${vehicle.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
															</td>
														</tr>
													))
												}
											</tbody>
										</Table>
									</div>
									<br></br>
									<div className="text-center">
										{/* Pagination controls */}
										<button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
											<Trans>Previous</Trans>
										</button>&nbsp;
										<button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
											<Trans>Next</Trans>
										</button>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</React.Fragment >
	)
}

export default VehicleList
